import React from 'react';

const experiences = [
  {
    id: 'experience-mawari',
    company: 'Mawari Technologies Inc.',
    role: 'Graphics Software Engineer',
    period: 'Mar 2025 – Present',
    location: 'Ontario, Canada',
    active: true,
    points: [
      'Led the port of Mawari\'s 3DFR (3D Free Viewpoint Reconstruction) pipeline into Unreal Engine 5 rendering workflows',
      'Implemented custom shader paths for real-time avatar reconstruction, XR rendering, and low-latency visual processing',
      'Optimized GPU skinning and reconstruction workloads for Meta Quest 3 platform constraints',
      'Investigated and modified low-level UE rendering paths affecting cloud streaming and frame delivery',
      'Resolved cross-device anti-aliasing artifacts in pixel streaming by tracing the issue through rendering behavior rather than surface symptoms',
    ],
  },
  {
    id: 'experience-naolito',
    company: 'Naolito Animation Studio',
    role: 'Software Developer Intern',
    period: 'Mar 2024 – Jul 2024',
    location: 'Málaga, Spain',
    active: false,
    points: [
      'Profiled and optimized application startup, reducing launch time to under 12 seconds.',
      'Cut Zoom-related overhead by about 80% by tracing performance regressions through runtime behavior.',
      'Improved REST request latency by roughly 30% through targeted backend and client-side fixes.',
    ],
  },
];

const Experience: React.FC = () => (
  <section id="experience" data-topic="rendering">
    <div className="content">

      <h2 className="section-heading">Experience</h2>

      <p className="prose" style={{ marginBottom: '1.25rem' }}>
        Professional graphics work began in March 2025 at Mawari. Earlier industry experience was general software engineering with a strong performance focus.
      </p>

      {experiences.map((exp, i) => (
        <div key={i} id={exp.id} className="entry section-anchor-target">
          <div className="entry-header">
            <div>
              <span className="entry-title">
                {exp.company}
                {exp.active && <span className="badge-live" style={{ marginLeft: '8px' }}>Active</span>}
              </span>
              <div className="entry-sub">{exp.role}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="entry-meta">{exp.period}</div>
              <div className="entry-meta">{exp.location}</div>
            </div>
          </div>
          <div className="entry-points">
            {exp.points.map((p, j) => (
              <div key={j} className="entry-point">{p}</div>
            ))}
          </div>
        </div>
      ))}

    </div>
  </section>
);

export default Experience;
